import React from "react";

export const Image = ({ prop }) => {
    return <img className="section__image" src={prop} alt="Интерфейс WCM" />;
};
